import $ from 'jquery';

let headerSearchShowButton = $( '.header-right__search #header-right__icon-search--show' );
let headerSearchFoldButton = $( '.header-right__icon-search--fold' );

headerSearchShowButton.on('click', function () {
	if ( $( '.search-form__search-field' ).is( ':visible' ) ) {
		$( '.search-form__search-field' ).focus();
	} else {

		if ( $( '.header-right__icon-search--input' ).is( ':hidden' ) ) {
			$( '.header-right__icon-search--input' ).toggle();
			$( '.header-right__search #header-right__icon-search--submit' ).show();
			$( '.header-right__icon-search--input' ).focus();
			headerSearchShowButton.hide();
			headerSearchFoldButton.css('display', 'flex');
		}
	}
} );

headerSearchFoldButton.on('click', function () {
	if ( $( '.header-right__icon-search--input' ).is( ':visible' ) ) {
		$( '.header-right__icon-search--input' ).toggle();
		$( '.header-right__search #header-right__icon-search--submit' ).hide();
		headerSearchFoldButton.hide();
		headerSearchShowButton.show();
	}

} );

